// extracted by mini-css-extract-plugin
export var container = "letterText-module--container--33hZ2";
export var small = "letterText-module--small--3ysre";
export var letter = "letterText-module--letter--3CWPu";
export var ch = "letterText-module--ch--2m0Bg";
export var title = "letterText-module--title--uekYp";
export var subtitle = "letterText-module--subtitle--J7MSX";